import React from 'react';

import { useApp } from '../../../store/AppContext';
import { orderedRange } from './lanes';
import TimelineDayCell from './TimelineDayCell';

/* Zone des jours d'une ligne : fond, barres, et création d'une affectation par glisser (manager)
   ou redimensionnement d'une barre. `match` identifie la ligne ({ devId } ou { rowKey }) ;
   onSelect(début, fin) reçoit la période glissée. */
export default function TimelineRowBody({ match, notWork, onSelect, style, children }) {
  const app = useApp();
  const { COL, days, isManager, setTimelineDrag, setTimelineResize, timelineDrag, timelineResize } =
    app;
  const [field, value] = Object.entries(match)[0];
  const N = days.length;
  const dayAt = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    return days[Math.max(0, Math.min(N - 1, Math.floor((e.clientX - rect.left) / COL)))];
  };
  const grid = { gridTemplateColumns: `repeat(${N}, ${COL}px)` };
  return (
    <div
      className="relative [user-select:none]"
      style={style}
      onMouseDown={(e) => {
        if (!isManager) return;
        const day = dayAt(e);
        if (day.we || day.ferie || notWork(day)) return;
        setTimelineDrag({ ...match, startIso: day.iso, endIso: day.iso });
      }}
      onMouseMove={(e) => {
        if (timelineDrag?.[field] !== value && timelineResize?.[field] !== value) return;
        app.timelineLastMouseX.current = e.clientX;
        const iso = dayAt(e).iso;
        if (timelineDrag?.[field] === value)
          setTimelineDrag((d) => (d ? { ...d, endIso: iso } : d));
        if (timelineResize?.[field] === value)
          setTimelineResize((r) => (r ? { ...r, currentIso: iso } : r));
      }}
      onMouseUp={() => {
        if (timelineDrag?.[field] === value) {
          const [s, e] = orderedRange(timelineDrag);
          setTimelineDrag(null);
          onSelect(s, e);
        }
        if (timelineResize?.[field] === value) {
          app.saveAssignmentResize(
            timelineResize.affId,
            timelineResize.edge,
            timelineResize.currentIso,
          );
          setTimelineResize(null);
        }
      }}
    >
      <div className="absolute [inset:0] grid [pointer-events:none]" style={grid}>
        {days.map((day) => (
          <TimelineDayCell key={day.iso} day={day} match={match} notWork={notWork} />
        ))}
      </div>
      <div className="absolute [inset:0] grid [align-items:start]" style={grid}>
        {children}
      </div>
    </div>
  );
}
